import React from "react";

import { useTranslation } from "react-i18next";
import { StyledModal, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";

import {
    store as modeOfSale,
    setGlobalDataIsUpdated,
    setIsLoading,
} from "../store";
import { store } from "@components/VerticalLayout/store";

import { capitalize } from "@helpers/general";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { useFetchGlobal } from "../../../../api/hooks";
import ErrorToast from "@components/Common/ErrorTost";
import {
    createDataConfig,
    createOldData,
    handleToastMessages,
    isInclude,
    updateSalesSupport,
} from "./hooks";

type ConfirmationModificationMessageType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    setIsEdited: Function;
    setDataIsUpdated: Function;
    associated: any[];
    setModalState: Function;
    salesSupport: any;
    dataSale: any;
    setLimit: Function;
    tags: any;
    setSalesSupport: any;
    setState: any;
};

export function ConfirmationModificationMessage({
    isModalOpened,
    setIsModalOpened,
    setIsEdited,
    setDataIsUpdated,
    associated,
    setModalState,
    salesSupport,
    dataSale,
    setLimit,
    tags,
    setSalesSupport,
    setState,
}: ConfirmationModificationMessageType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const { userID, franchiseID, operatorID } = useSnapshot(store);
    const {
        salesSupports,
        shopsModeSaleData,
        editedDataModeOfSale,
    } = useSnapshot(modeOfSale);

    const [error, setError] = React.useState<boolean>(false);
    const [isSalesSupportEmpty, setIsSalesSupportEmpty] = React.useState<
        boolean[]
    >([]);
    const [isDataChanged, setIsDataChanged] = React.useState<boolean>(false);
    const uuidUser = localStorage.getItem("uuidUser");

    async function editAllModeOfSale(isFranchiseAndBoutique: boolean) {
        toast.dismiss();
        setIsLoading(true);
        let dataConfig: any[] = [];
        let updatedData: any;
        let rowsToUpdate = isFranchiseAndBoutique
            ? associated
            : [associated[0]];
        rowsToUpdate.forEach((el: any) => {
            dataConfig.push(
                createDataConfig(
                    el,
                    userID,
                    franchiseID,
                    operatorID,
                    uuidUser,
                    tags,
                    editedDataModeOfSale,
                    salesSupport
                )
            );
            let oldData = createOldData(el);
            updatedData = updateSalesSupport(
                oldData,
                el,
                editedDataModeOfSale,
                salesSupport
            );
        });
        try {
            await fetchGlobal<any>(
                `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_sale`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ dataConfig, updatedData }),
                }
            );
        } catch (e) {
            ErrorToast(t("There's an error"));
            setError(true);
        }
        handleToastMessages(
            error,
            isSalesSupportEmpty,
            isDataChanged,
            setLimit,
            setModalState,
            setDataIsUpdated,
            setGlobalDataIsUpdated,
            setIsLoading,
            setSalesSupport,
            setState
        );
    }

    React.useEffect(() => {
        let allModeOfSaleShop: any = [];
        let localSalesSupport: boolean[] = [];
        if (shopsModeSaleData.data !== undefined) {
            shopsModeSaleData.data.forEach((el: any) => {
                if (el.subRows !== undefined)
                    el.subRows.forEach((element: any) => {
                        allModeOfSaleShop.push(element.shopId);
                    });
            });
        }
        salesSupports.forEach((el: any) => {
            if (allModeOfSaleShop.includes(el.id)) {
                let filteredSalesSupport: any = el.salesSupport.filter(
                    (value: any) => salesSupport.includes(value)
                );
                localSalesSupport.push(
                    filteredSalesSupport.length > 0 &&
                        salesSupport.length === filteredSalesSupport.length
                );
            }
        });
        let localDataChanged: any = Object.values(editedDataModeOfSale.data)[0];
        let local = [...localDataChanged.tag];

        setIsDataChanged(
            dataSale.display_name !== localDataChanged.display_name ||
                (!dataSale.tag.every((el: any) => isInclude(el, local)) &&
                    !local.every((el: any) => isInclude(el, dataSale.tag)))
        );

        setIsSalesSupportEmpty(localSalesSupport);
    }, [
        shopsModeSaleData,
        salesSupports,
        salesSupport,
        dataSale,
        editedDataModeOfSale.data,
        t,
    ]);
    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setIsLoading(false);
                    setIsModalOpened(false);
                    setDataIsUpdated(true);
                    setIsEdited(false);
                }}
            >
                <span
                    style={{
                        fontFamily: "Segoe UI Semibold",
                        color: "#2b2828",
                        fontSize: "20px",
                    }}
                >
                    {capitalize(t("Alert"))}
                </span>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {t(
                        'Do you want to apply these changes for all stores? \n Attention ! If you click on "Validate", the specific settings of the shops will be modified.'
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setIsModalOpened(!isModalOpened);
                        setModalState((prev: any) => ({
                            ...prev,
                            isAddModeOfSaleClicked: false,
                        }));
                        setDataIsUpdated(true);
                        setIsEdited(false);
                        editAllModeOfSale(false);
                        setIsLoading(false);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        setIsModalOpened(!isModalOpened);
                        editAllModeOfSale(true);
                        setGlobalDataIsUpdated(true);
                        setModalState((prev: any) => ({
                            ...prev,
                            isAddModeOfSaleClicked: false,
                        }));
                        setIsEdited(false);
                        setIsLoading(false);
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
